import { Button, Typography } from "@material-ui/core";
import React, { useMemo} from "react";
import { useBuilder } from "../../useBuilder";

export function AssistantFeelingStuck(props: {
	onSubmit: (assetId: string) => void;
}) {
	const { onSubmit } = props;
	const builder = useBuilder();

	const wordCount = useMemo(() => builder.builderAsset.text.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim().split(" ").length, [builder.builderAsset.text])
	const disabled = wordCount < 100;
	const buttonText = disabled ? "100 words required" : "Get ideas for my sermon";

	return (
		<>
			<Typography
				color="textPrimary"
				style={{ margin: 12, paddingBottom: 10 }}
			>
				Generate ideas and suggestions for your sermon.
			</Typography>
			<Button
				onClick={() => onSubmit(builder.builderAsset.id)}
				variant="contained"
				color="primary"
				disabled={disabled}
				style={{ marginTop: 10, marginBottom: 15 }}
			>
				{buttonText}
			</Button>
		</>
	);
}
